import React, { useEffect, useMemo, useState } from 'react';
import Dropdown from '../../../../Global/Dropdown';
import SRS from '../../../../../services/StudentRecordService';
import ConfigCard from '../../blocks/ConfigCard';
import { GetBrandedCurriculumName, GetBrandedAppName } from '../../../../../services/BrandingService';
import { defaultCurriculumDisplayName } from '../../../../Reports/containers/ReportSettings/SelectSkillsCurriculum/defaultCurriculumConfig';

export default function SelectCurriculum(props) {

  const { selectedCurriculum, setSelectedCurriculum } = props;
  const [availableCurriculums, setAvailableCurriculums] = useState([]);

  const fetchAvailableCurriculums = async () => {
    const response = await SRS.listCurriculums();
    console.log('response', response);
    if (response && response.listCurriculums) {
      setAvailableCurriculums(response.listCurriculums);
    }
  }
  useEffect(() => {
    if (!availableCurriculums.length) {
      console.log('fetchAvailableCurriculums')
      fetchAvailableCurriculums();
    }
  }, [availableCurriculums]);

  const updateSetting = (e, locale) => {
    const curriculumId = e.value;
    const updatedCurriculumSetting = findAndReplaceCurriculum(selectedCurriculum, curriculumId, locale);
    setSelectedCurriculum(updatedCurriculumSetting);
  }

  const findAndReplaceCurriculum = (existingSetting, value, locale) => {
    const curriculum = availableCurriculums.find(curriculum => curriculum.curriculumId === value);

    // if the user doesn't already have a curriculum setting, create a new one with the new selection
    if (!existingSetting) return [curriculum]

    // if the user already has a curriculum setting, update the existing setting
    const updatedCurriculum = [...existingSetting];
    const indexToUpdate = updatedCurriculum.findIndex(curriculum => curriculum.locale === locale);
    if (indexToUpdate !== -1) {
      updatedCurriculum[indexToUpdate] = curriculum;
    } else {
      updatedCurriculum.push(curriculum);
    }
    return updatedCurriculum
  }

  const enOptions = useMemo(() => {
    return availableCurriculums.filter(curriculum => curriculum.locale === 'EN_US').map(curriculum => {
      const label = curriculum.displayName === defaultCurriculumDisplayName ? GetBrandedCurriculumName() : curriculum.displayName;
      return { value: curriculum.curriculumId, label, locale: curriculum.locale }
    });
  }, [availableCurriculums]);

  const esOptions = useMemo(() => {
    return availableCurriculums.filter(curriculum => curriculum.locale === 'ES_MX').map(curriculum => {
      const label = curriculum.displayName === defaultCurriculumDisplayName ? GetBrandedCurriculumName() : curriculum.displayName;
      return { value: curriculum.curriculumId, label, locale: curriculum.locale }
    });
  }, [availableCurriculums]);

  /**
   * rendering
   */
  if(!availableCurriculums.length) return null;

  const selectedENOption = enOptions.find(option => option.value === selectedCurriculum?.find(curriculum => curriculum.locale === 'EN_US')?.curriculumId) || enOptions[0];
  const selectedESOption = esOptions.find(option => option.value === selectedCurriculum?.find(curriculum => curriculum.locale === 'ES_MX')?.curriculumId) || esOptions[0];

  return <ConfigCard title='CHOOSE CURRICULUM AVAILABLE IN REPORTS' description={`${GetBrandedAppName()} will show the selected curriculum's scope and sequence in skills reports.`}>
    {enOptions?.length && <div className='configure-scales-reporting-row'>
      <div className='configure-reporting-dropdown'>
        <label>Choose Curriculum for English</label>
        <Dropdown
          options={enOptions}
          value={selectedENOption}
          onChange={(e) => updateSetting(e, 'EN_US')}
          isDisabled={false}
        />
      </div>
    </div>}
    {esOptions?.length && <div className='configure-scales-reporting-row'>
      <div className='configure-reporting-dropdown'>
        <label>Choose Curriculum for Spanish</label>
        <Dropdown
          options={esOptions}
          value={selectedESOption}
          onChange={(e) => updateSetting(e, 'ES_MX')}
          isDisabled={false}
        />
      </div>
    </div>}
  </ConfigCard>
}